import Lang from 'assets/Lang';
import ModalLoading from 'common/components/modals/ModalLoading';
import DropAlert from 'common/components/views/DropAlert';
import Fetch from 'common/helpers/Fetch';
import Funcs from 'common/helpers/Funcs';
import Strings from 'common/helpers/Strings';
import ApiConst from 'consts/ApiConst';
import AppConst from 'consts/AppConst';
import { Alert, Linking, Platform } from 'react-native';
import Mailer from 'react-native-mail';
import Configs from 'utils/Configs';
import CodePushService from './CodePushService';
import FirebaseService from './FirebaseService';
import StorageService from './StorageService';

export default {
  init: async (callback = () => {}) => {
    if (__DEV__) return;
    const errorUtils = global?.ErrorUtils || global?.__ErrorUtils;
    if (!errorUtils || typeof errorUtils.setGlobalHandler !== 'function') return;
    // const defaultHandler = errorUtils.getGlobalHandler?.();
    errorUtils.setGlobalHandler(async (error, isFatal) => {
      if (isFatal) {
        let message = error?.message;
        if (message) {
          if (typeof message !== 'string') message = JSON.stringify(message);
          message = message.substr(0, message.length > 100 ? 100 : message.length);
        }
        Alert.alert(Lang?.errorSupport?.title, Strings.format(Lang?.errorSupport?.detail, [message]), [
          { text: Lang?.cancel },
          {
            text: Lang?.errorSupport?.support,
            onPress: async () => {
              const email = AppConst.DEV_EMAIL || 'xgitdev@gmail.com';
              const url = Configs.appConfigs.messenger || AppConst.FACEBOOK_MESSENGER_URL;
              if (url) Linking.openURL(url);
              else if (email) {
                try {
                  Mailer.mail(
                    {
                      subject: `Support ${AppConst.NAME} ${Platform.OS} ${AppConst.VERSION}`,
                      recipients: [AppConst.DEV_EMAIL],
                      body: `Support ${AppConst.NAME} ${Platform.OS} ${AppConst.VERSION}`
                    },
                    (err, event) => {
                      Funcs.log('[Email Error]', err, event);
                      ModalLoading.hide();
                      if (err === 'not_available') err = 'Email not available!.';
                      DropAlert.error('', err || Lang?.fail || 'ERRORR');
                    }
                  );
                } catch (err) {
                  Funcs.log(err);
                  FirebaseService.logError(err);
                  DropAlert.error('', (err && err.message) || Lang?.fail || 'ERRORR');
                }
              }
            }
          }
        ]);

        if (callback) callback(message);

        // defaultHandler?.(error, isFatal);
      }
    });
  },

  pushException: async (message) => {
    // Lấy thông tin codepush
    let exceptionData = { message };
    try {
      const codepushInfo = await CodePushService.getCurrentInfo();
      const { packageHash, deploymentKey, appVersion, label } = codepushInfo || {};
      exceptionData = { ...exceptionData, packageHash, deploymentKey, appVersion, label };

      const res = await Fetch.post(ApiConst.USER.UPDATE_EXCEPTION, exceptionData, { disableAlert: true });
      if (res.status === 200) {
        // Check nếu codepush version giống ở client, thì xoá codepush, và delay update 2h.
        const data = res.data;
        const hash = data?.hash;
        let max = 30;
        if (AppConst.IS_DEV_BUILD) max = 10;
        if (hash && codepushInfo && data?.total >= max) {
          StorageService.save('CODEPUSH_DELAY_CHECK_TIME_TO', Date.now() + 2 * 60 * 60 * 1000);
          CodePushService.resetCodepushData();
          Funcs.log('## RESET CODEPUSH DATA');
          CodePushService.restartApp();
        }
      }
    } catch (err) {
      console.log('ERROR', err);
    }
  }
};
